import onElelementExistRunOnce from 'helpers/jquery/onElementExistRunOnce';

onElelementExistRunOnce('#agro-recommendation-index-table', () => {
  void import('./internal/agro-recommendation-index-table')
    .then(({ default: Component }) => Component());
});
